(() => {
  const selectors = {
    root: "[data-aw-page-media-costume]",
    trigger: "[data-aw-page-media-costume-modal-trigger]",
    modal: "[data-aw-page-media-costume-modal]",
    close: "[data-aw-page-media-costume-modal-close]"
  };

  const instances = new Map();

  class AWPageMediaCostume {
    constructor(root) {
      this.root = root;
      this.trigger = root.querySelector(selectors.trigger);
      this.modal = root.querySelector(selectors.modal);
      this.closes = Array.from(root.querySelectorAll(selectors.close));
      this.onKeydown = this.handleKeydown.bind(this);
      this.onTriggerClick = this.open.bind(this);
      this.onCloseClick = this.close.bind(this);

      this.bind();
    }

    bind() {
      if (this.trigger) {
        this.trigger.addEventListener("click", this.onTriggerClick);
      }

      this.closes.forEach((button) => {
        button.addEventListener("click", this.onCloseClick);
      });
    }

    open() {
      if (!this.modal) {
        return;
      }

      this.modal.hidden = false;
      this.modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("is-aw-page-media-costume-modal-open");
      document.addEventListener("keydown", this.onKeydown);
    }

    close() {
      if (!this.modal) {
        return;
      }

      this.modal.hidden = true;
      this.modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("is-aw-page-media-costume-modal-open");
      document.removeEventListener("keydown", this.onKeydown);

      if (this.trigger) {
        this.trigger.focus();
      }
    }

    handleKeydown(event) {
      if (event.key === "Escape") {
        this.close();
      }
    }

    destroy() {
      if (this.trigger) {
        this.trigger.removeEventListener("click", this.onTriggerClick);
      }

      this.closes.forEach((button) => {
        button.removeEventListener("click", this.onCloseClick);
      });

      document.removeEventListener("keydown", this.onKeydown);
      document.body.classList.remove("is-aw-page-media-costume-modal-open");
    }
  }

  function init(root) {
    const sectionId = root.closest("[id]")?.id || root.dataset.sectionId || `aw-page-media-costume-${instances.size}`;

    if (instances.has(sectionId)) {
      instances.get(sectionId).destroy();
    }

    instances.set(sectionId, new AWPageMediaCostume(root));
  }

  function initAll(container = document) {
    container.querySelectorAll(selectors.root).forEach(init);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target.querySelector(selectors.root);

    if (!root) {
      return;
    }

    const sectionId = root.closest("[id]")?.id || root.dataset.sectionId;
    const instance = sectionId ? instances.get(sectionId) : null;

    if (instance) {
      instance.destroy();
      instances.delete(sectionId);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }
})();
